import * as React from 'react';
import { translate } from 'react-i18next';
import { IArticlesData } from 'models/magazine/article/articles';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
require('./style.css');
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { nullCheck } from 'helpers/common';
import { IArticleCardAction } from 'models/magazine/article/articlecard';

interface IProps {
	articlesData: IArticlesData;
	t?: (key: string) => string;
	getArticleCard: (id: string) => IArticleCardAction;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MostReadArticles extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		if (this.props.articlesData.error) {
			return <ErrorPage {...this.props} message={this.props.articlesData.message} />;
		}

		const { t } = this.props;

		let mostReadArticles = [];
		if (nullCheck(this.props.articlesData)) {
			mostReadArticles = this.props.articlesData.items;
		}

		const listProps: IItemCardList = {
			items: mostReadArticles,
			itemType: c.NODE_TYPE_MAGAZINE_ARTICLE_ITEM_SMALL_CARD,
			goToCard: (id: string) => this.props.getArticleCard(id),
		};

		return (
			<div className="mostReadArticlesContainer desktopShown">
				<div className="topText">
					<div className="smallText">{t('Magazine_Article_MostRecentArticles_Label_PastWeek')} </div>
					<div className="bigText">{t('Magazine_Article_MostRecentArticles_Label_MostReadArticles')}</div>
				</div>
				<ItemCardList {...listProps} />
			</div>
		);
	}
}
export { MostReadArticles };
